import { AccountInfo, InteractionRequiredAuthError } from '@azure/msal-browser'

import { avisarProblemaDeSesion } from '@/common/helpers/avisoSesion'
import { getProtectedResources } from '@/core/msal/authConfig'
import { msalInstance, redirectToLoginPreservingRoute } from '@/core/msal/msal'

interface IAuthHeader {
  accessToken: string
  currentAccount: AccountInfo
}

export const authHeader = async (forceRefresh = false): Promise<IAuthHeader> => {
  const currentAccount = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0]

  if (!currentAccount) {
    // Sesión perdida (ej. storage limpiado): recuperar re-autenticando en vez de fallar en cadena
    redirectToLoginPreservingRoute()
    throw Error('No active account! Verify a user has been signed in and setActiveAccount has been called.')
  }

  try {
    // Backend API token (el token de Graph se adquiere solo donde se necesita, p. ej. useAvatar)
    const response = await msalInstance.acquireTokenSilent({
      account: currentAccount,
      scopes: getProtectedResources().apiPerseverance.scopes,
      forceRefresh,
    })

    return {
      accessToken: response.accessToken,
      currentAccount,
    }
  } catch (error) {
    // Sesión caducada tras suspensión larga: el refresh silencioso ya no alcanza y MSAL
    // exige interacción — re-autenticar de inmediato en vez de dejar la app "cargando".
    // Los errores de red hacia Microsoft NO redirigen (el login tampoco funcionaría offline)
    if (error instanceof InteractionRequiredAuthError) {
      redirectToLoginPreservingRoute()
      throw error
    }

    // Transitorio: se avisa una vez y se sigue relanzando, para que cada llamador decida. Antes
    // el error subia mudo y el usuario veia pantallas vacias sin explicacion, porque no todos
    // los llamadores avisan.
    avisarProblemaDeSesion(error)

    throw error
  }
}
